import { JobObjectStage, JobObjectStageStatus } from './interfaces/job';

export const doesStageHasFailures = (status: JobObjectStageStatus) => {
  return [JobObjectStageStatus.COMPLETED_WITH_FAILURES, JobObjectStageStatus.FAILED].includes(
    status
  );
};

export const shouldRenderObjectDetails = (isLoadOnly: boolean, objectStages: JobObjectStage[]) => {
  return (
    !isLoadOnly || (isLoadOnly && objectStages.find(stage => stage.stage === 'load')!.hasFailures)
  );
};
